import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelSearchSelect } from '../elements/floatingLabelInput/FloatingLabelInput';
import protocolSubcategoryApi from '../../api/protocol-subcategory-api';
import { useInfiniteOptions, withSelectedOption } from '../../hooks/useInfiniteOptions';
import { toSubcategoryOption } from '../../hooks/useSubcategoryLookup';

// One category's items for the protocol form, loaded a page at a time.
// Loaded items are reported through `onItemsLoaded` so the form can resolve
// their category and label later.
export default function SubcategoryPicker({
  category,
  label,
  value,
  selectedOption,
  onChange,
  onItemsLoaded,
}) {
  const fetchPage = useCallback(
    async (page, limit, search) => {
      const { data, success } = await protocolSubcategoryApi.getAll(page, limit, {
        category,
        searchTerm: search || undefined,
      });
      if (!success) return null;
      return { items: data.items.map(toSubcategoryOption), totalPages: data.totalPages };
    },
    [category],
  );
  const { items, loading, onSearch, onPopupScroll } = useInfiniteOptions(fetchPage, {
    reloadKey: category,
  });

  useEffect(() => {
    onItemsLoaded(items);
  }, [items, onItemsLoaded]);

  return (
    <FloatingLabelSearchSelect
      label={label}
      placeholder="Izaberite stavku"
      allowClear
      value={value}
      options={withSelectedOption(items, selectedOption)}
      loading={loading}
      onSearch={onSearch}
      onPopupScroll={onPopupScroll}
      onChange={(val) => onChange(val ?? null)}
    />
  );
}

SubcategoryPicker.propTypes = {
  category: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  selectedOption: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  onChange: PropTypes.func.isRequired,
  onItemsLoaded: PropTypes.func.isRequired,
};
